import { combineReducers, configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import flowChartSlice from './flowChartSlice'
import taskSlice from './taskSlice'
import userSlice from './userSlice'
import uploadSlice from './uploadSlice'
import menuReducer from './menuSlice'
const persistConfig = {
  key: 'root',
  storage,
}
const rootReducer = combineReducers({
  user: userSlice,
  flowChart: flowChartSlice,
  task: taskSlice,
  upload: uploadSlice,
  menu: menuReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(logger),
  reducer: persistedReducer,
})

export type RootState = ReturnType<typeof store.getState>
export type SliceDispatch = typeof store.dispatch
export default store
export const persistor = persistStore(store)
